<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >

      <!--      :otherParams="{'isDealerId':navSwitch}"-->
      <template v-slot:[toolbarConfig.templatelSlots]>
        <div class="top_btns_box"
             style="display: flex"
        >
          <div class="status_box">
            <!--            <span class="status_item" :class="!navSwitch?'active':''" @click="changeNav(0)">全部</span>-->
            <span class="status_item active" @click="showRecord(1)">分配记录</span>
          </div>
          <div class="btns_box">
            <vxe-button v-if="!navSwitch" @click="showAssignPopFunc">
              分配
            </vxe-button>
          </div>
        </div>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <formModal
        title="待分配的非企微客户"
        centered
        :footer="null"
        :maskClosable="false"
        :width="1200"
        :closable="true"
        :visible="editModalVisible"
        @cancelled="closeDetailPop"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :userId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
          @closeParent="closeDetailPop"
          @openParent="openDetailPop"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>


      <!--      <inheritRecord v-if="editModalVisible"-->
      <!--                     :rowId="editRowId"-->
      <!--                     ref="inheritRecord"-->
      <!--                     @cancelled="closeEdit()"-->
      <!--                     @saved="closeEdit(true)"-->
      <!--      >-->


      <!--      </inheritRecord>-->

    </formModal>

    <!-- 选择分配人 弹窗 -->
    <a-modal
        title="选择分配人"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="true"
        v-model="showAssignPop"
        :width="1200"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <sonDeptUsersList
          @closeParent="closePop"
          :assignIdArr="assignIdArr"
          :type="1"
          v-if="showAssignPop"
          ref="sonDeptUsersList"
          @close="closePop"
      >
      </sonDeptUsersList>
    </a-modal>

    <!-- 分配记录 弹窗 -->
    <a-modal
        title="分配记录"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="true"
        v-model="showAssignRecordPop"
        :width="1200"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <inheritRecord v-if="showAssignRecordPop">


      </inheritRecord>
    </a-modal>


  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除

import detailForm from "@//pages/web/client/clientInherit/detail/allocatedList";
import sonDeptUsersList from "./detail/inheritUsersList";
import inheritRecord from "@/pages/web/client/clientInheritRecord"


//弹出层组件
import {mapMutations, mapState} from "vuex";
import {dataApi} from "@/services/client/inherit.js";
// import user from "@/services/user";

const fac = XGrid.factory;

//列表接口
// const url = this.navSwitch ? api.client.SCRM + '/custAssignRecord' : api.client.INHERIT + '/getQuitUserPageList';
const url = api.client.INHERIT + '/getQuitUserPageList';

//主键
const rowId = "userId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  // fac.makeColumnSeqDefault(),
  fac.makeColumn("userName", "已离职成员", 'auto', 'center'),
  fac.makeColumn("dealerName", "经销商", 'auto', "center"),
  fac.makeColumn("regionName", "经理部", 'auto', "center"),
  fac.makeColumn("custNum", "待分配客户数", 'auto', "center"),
  fac.makeColumn("quitDate", "离职时间", 'auto', "center"),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "userName"},
  {
    field: "regionId",
    // 'customSearch': true,
    title: "经理部",
    type: "select",
    options: [],
  },
  {
    field: "dealerName",
    // 'customSearch': true,
    title: "经销商",
    type: "search-select",
    options: [],
  },
  {
    field: 'quitDate',
    title: "离职时间",
    type: 'dateRange',
  }
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);

  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    deptName: this.dealerOptions,
    regionId: this.regionOptions,
  })

}


export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   // delRow: 'DELETE',
  //   // importMethod:'IMPORT',
  //   // exportMethod:'EXPORT',
  // },
  components: {
    detailForm,
    sonDeptUsersList,
    inheritRecord,
  },
  computed: {
    ...mapState("account", {currUser: "user"}),

  },
  watch: {
    'formData.regionId'(val) { //经理部 联动经销商
      this.formData.dealerName =null
      this.getDealerData(val)
    }
  },
  data() {
    return {
      navSwitch: 0,
      showAssignPop: false,
      regionOptions: [],
      dealerOptions: [],
      assignIdArr: [], //将选中的离职成员的客户（多选）都分配给分配人（单选）
      // popConfig,
      showAssignRecordPop: false,
      columns,
      rowId,
      url,
      formData: null,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: [],
      startDate: this.$store.state.setting.startTime || null,
      endDate: this.$store.state.setting.endTime || null,
      isTodayFollow: this.$store.state.setting.isTodayFollow || null,
      isNotFollow: this.$route.query.isNotFollow,
      fromIndexParam: this.$route.query.fromIndexParam,
      showAllocated: false,
    };
  },
  mounted() {
    this.formData = this.$refs.grid.$refs.xGrid.formData; //获取筛选项
  },
  methods: {

    ...mapMutations('setting', ['setStartTime', 'setEndTime', 'setIsTodayFollow']),
    loadBaseData,
    showAllocatedList() {
      this.showAllocated = true
    },
    showRecord() {

      this.showAssignRecordPop = true;

      // switch (type) {
      //   case 0:
      //     this.$router.push({
      //       path: '/client/clientInherit'
      //     })
      //     break;
      //   case 1:
      //     this.$router.push({
      //       path: '/client/clientInheritRecord'
      //     })
      //     break;
      // }
    },
    // changeNav(status) { //切换nav状态
    //   this.navSwitch = status;
    //   const vm = this;
    //   this.$nextTick(() => {
    //     vm.refresh()
    //   })
    // },
    // 弹出分配人列表 选择分配人进行分配
    showAssignPopFunc(row) {
      //判断操作 是批量还是单条数据
      if (!row.userId) { //批量
        let rowArr = this.getRows();
        if (!rowArr.length) {
          this.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          this.assignIdArr = rowResult.map(item => item.userId);
          this.showAssignPop = true;
        }
      } else {  //单条数据
        this.assignIdArr.push(row.userId);
        this.showAssignPop = true;
      }
    },
    // 关闭弹窗
    closePop() {
      this.showAssignPop = false; //分配人列表
      this.refresh();
    },
    //关闭详情
    closeDetailPop() {
      this.editModalVisible = false;
      this.refresh();
    },
    //打开详情
    openDetailPop() {
      this.editModalVisible = true;
    },
    async createAccount() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length != 1) {
        this.$message.error('请选择一条数据');
        return;
      }
      console.log(rows)
      const userId = rows[0].userId
      console.log(userId)
      await dataApi.accountNumber(userId).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg)
        }
        console.log(res)
        this.refresh();
      }).catch(e => {
        console.log(e);
      })
    },
    merchants() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      console.log(rows)
      this.userIdList = rows.map((i) => {
        return i.userId;
      }).join(',')
      console.log(this.userIdList)
      this.chooseOpenPop('merchantsAuthorization', 1)
    },
    closeLog() {
      this.logModalVisible = false;
    },
    /**
     * 经理部 经销商联动数据
     * @param id
     * @return {Promise<void>}
     */
    async getDealerData(id) {
      let dealer = {
        isRegion: 0,
        isDealer: 1,
        'filter.eq.parentId': id,
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);
      this.loadSearchOption({
        dealerName: this.dealerOptions,
      })
    },
  },
};
</script>

<style lang="less" scoped>

.top_btns_box {
  padding-top: 20px;
}

.status_box {
  margin: 0 30px 12px 0;
  position: relative;
  top: -6px;

  .status_item {
    width: 120px;
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 38px;
    display: inline-block;
    background-color: #E9F5FC;
    cursor: pointer;

    &.active {
      background-color: #D90B18;
      color: #fff;
    }
  }
}

</style>
